import(/* webpackMode: "eager", webpackExports: ["MatchDetails"] */ "/app/apps/pickleball/src/modules/results/list/MatchDetails.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RTEProvider"] */ "/app/packages/ui/src/components/global/RTEProvider.tsx");
